import React, { useState } from "react";
import { Link } from "react-router-dom";
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { api } from "../../api/api";
import { category_three_url } from "../../api/urls";

const Brands = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await api.get(category_three_url);
      setData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handlePopoverOpen = async (event) => {
    setAnchorEl(event.currentTarget);
    // Fetch data directly when the popover opens
    await fetchData();
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <nav>
        <ul className="all-category">
          <li>
            <Link
              to="/mens_wear"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
            >
              MEN'S WEAR
            </Link>
          </li>
          <li>
            <Link
              to="/womens_wear"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
            >
              WOMEN'S WEAR
            </Link>
          </li>
          <li>
            <Link
              to="/kids_wear"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
            >
              KIDS WEAR
            </Link>
          </li>
        </ul>
      </nav>
      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: 'none', boxShadow: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography 
          sx={{ 
            p: 4,
            width: '100vw', 
            height: '400px', 
            background: '#FFFFFF',
            color: 'black',
            boxShadow: 'none',
          }}
        >
          {data.length > 0 ? (
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
              {data.slice(0, 50).map((item) => ( // Show only first 50 items
                <div key={item.id} style={{ flex: '1 1 20%', padding: '10px' }}>
                  <div>
                    {item.printable_name}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            'No data available.'
          )}
        </Typography>
      </Popover>
    </div>
  );
};

export default Brands;
